if(typeof flarum.reg.get('flarum-tags', 'forum/components/TagHero') === 'undefined') { const e = new Error("Cannot find module 'flarum.reg.get('flarum-tags', 'forum/components/TagHero')'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = flarum.reg.get('flarum-tags', 'forum/components/TagHero');